import { render, staticRenderFns } from "./YoutubePlayer.vue?vue&type=template&id=039653bc&"
import script from "./YoutubePlayer.vue?vue&type=script&lang=js&"
export * from "./YoutubePlayer.vue?vue&type=script&lang=js&"
import style0 from "./YoutubePlayer.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports